import type { AnnotationItemJson, AnnotationSetJson } from 'contracts/PMIJson';

import type { AnnotationItem } from './AnnotationItem';

export class AnnotationSet {
  public readonly name: string;
  private readonly _annotations: AnnotationItem[];
  private readonly _annotationSets: AnnotationSet[];

  constructor(
    index: number,
    { setName, setIDs, itemIDs }: AnnotationSetJson,
    annotations: Map<AnnotationItemJson['id'], AnnotationItem>,
    annotationSets: Map<number, AnnotationSet>,
  ) {
    this.name = setName || `${index}`;
    this._annotations = [];
    this._annotationSets = [];
    for (const itemID of itemIDs || []) {
      const annotation = annotations.get(itemID);
      if (annotation) {
        this._annotations.push(annotation);
      }
    }
    for (const setID of setIDs || []) {
      const annotationSet = annotationSets.get(setID);
      if (annotationSet) {
        this._annotationSets.push(annotationSet);
      }
    }
    //Add itself to annotationSets
    annotationSets.set(index, this);
  }

  public get annotations(): Iterable<AnnotationItem> {
    const annotations = this._annotations;
    const annotationSets = this._annotationSets;
    return {
      *[Symbol.iterator]() {
        for (const annotation of annotations) {
          yield annotation;
        }
        for (const annotationSet of annotationSets) {
          yield* annotationSet.annotations;
        }
      },
    };
  }
}
